import {h, Fragment} from "preact"
import { useActions, useAppState } from "@nosto/preact"
import { defaultConfig, sortOptions } from "../config"
import Sidebar from "./Sidebar"

export default function({ sidebarOpen, toggleSidebar }) {
    const { loading, query, response, pageType } = useAppState();
    const { updateSearch } = useActions();

    const selectedFiltersCount =
        query.products?.filter?.reduce(
            (acc, curr) =>
                acc + (Array.isArray(curr.value) ? curr.value.length : 1),
            0
        ) ?? 0;
    const activeSort =
        sortOptions.find(option =>
            option.value.sort.every(v1 =>
                query.products?.sort?.find(
                    v2 => v1.field === v2.field && v1.order === v2.order
                )
            )
        )?.id ?? defaultConfig.sort.id;
    const docCount = response.products?.total ?? 0;

    return (
        <div class="ns-header-controls px-4 py-[28px] lg:px-0 lg:py-0">

            <div class="ns-header-inner relative flex items-center justify-between pt-4 lg:pt-14 pb-2 tw-border-solid border-gray-200 flex-row flex-wrap lg:flex-nowrap">
                {/* product count */}
                <div
                    class="ns-product-count mt-2 w-full relative text-left"
                    data-nosto-element="totalResults"
                    role="status"
                >
                    <b class="pr-2">All Products</b>
                    <span>({docCount} Results)</span>
                </div>

                {/* filter toggle */}
                <div class="ns-filter-toggle flex justify-start items-center">
                    <button
                        type="button"
                        class="flex flex-nowrap items-center"
                        onClick={toggleSidebar}
                    >
                        <span class="button-label">Filter</span>
                        {sidebarOpen
                            ?   <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-2">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.13062 8.00003L12.565 4.56563C12.8778 4.25283 12.8778 3.74723 12.565 3.43443C12.2522 3.12163 11.7466 3.12163 11.4338 3.43443L7.99942 6.86883L4.56502 3.43443C4.25222 3.12163 3.74662 3.12163 3.43382 3.43443C3.12102 3.74723 3.12102 4.25283 3.43382 4.56563L6.86822 8.00003L3.43382 11.4344C3.12102 11.7472 3.12102 12.2528 3.43382 12.5656C3.58982 12.7216 3.79462 12.8 3.99942 12.8C4.20422 12.8 4.40902 12.7216 4.56502 12.5656L7.99942 9.13123L11.4338 12.5656C11.5898 12.7216 11.7946 12.8 11.9994 12.8C12.2042 12.8 12.409 12.7216 12.565 12.5656C12.8778 12.2528 12.8778 11.7472 12.565 11.4344L9.13062 8.00003Z" fill="#222222"></path><mask id="mask0_33:1711" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="10" height="10"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.13062 8.00003L12.565 4.56563C12.8778 4.25283 12.8778 3.74723 12.565 3.43443C12.2522 3.12163 11.7466 3.12163 11.4338 3.43443L7.99942 6.86883L4.56502 3.43443C4.25222 3.12163 3.74662 3.12163 3.43382 3.43443C3.12102 3.74723 3.12102 4.25283 3.43382 4.56563L6.86822 8.00003L3.43382 11.4344C3.12102 11.7472 3.12102 12.2528 3.43382 12.5656C3.58982 12.7216 3.79462 12.8 3.99942 12.8C4.20422 12.8 4.40902 12.7216 4.56502 12.5656L7.99942 9.13123L11.4338 12.5656C11.5898 12.7216 11.7946 12.8 11.9994 12.8C12.2042 12.8 12.409 12.7216 12.565 12.5656C12.8778 12.2528 12.8778 11.7472 12.565 11.4344L9.13062 8.00003Z" fill="white"></path></mask><g mask="url(#mask0_33:1711)"></g>
                                </svg>
                            :   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" fill="none" class="ml-2">
                                    <path stroke="#000" stroke-linecap="round" stroke-width="1.5" d="M1 8.75h12"></path><circle cx="9.25" cy="8.75" r="1.75" fill="#000" stroke="#000"></circle><path stroke="#000" stroke-linecap="round" stroke-width="1.5" d="M1 2.375h12"></path><circle cx="5.25" cy="2.25" r="1.75" fill="#000" stroke="#000"></circle>
                                </svg>
                        }
                    </button>
                </div>

                {/* sort products */}
                <div class="ns-sort relative flex justify-end items-center">
                    <select
                        name="ns-sort-dropdown"
                        id="ns-sort-dropdown"
                        class="relative text-right"
                        value={activeSort}
                        onChange={(e) => {
                            updateSearch({
                                products: {
                                    sort: sortOptions.find(
                                        v => v.id === e?.target?.value
                                    )?.value?.sort,
                                },
                            })
                        }}
                    >
                        {sortOptions.map(o => (
                            <option value={o.id}>{o.value.name}</option>
                        ))}
                    </select>
                </div>
            </div>

            <Sidebar 
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
            />
        </div>
    )
}
